import axios from 'axios';
import { uuid } from './utils';
import { ERROR_CODE } from './error-code';

// import Vue from 'vue';
// import Dialog from 'kpc/components/dialog';
const env = process.env;
// 超时时间 10 s
let timeout = 12000000;
// 默认配置，baseUrl，timeout
const initConfig = () => {
  let config = {
    timeout
  };
  if (env.VUE_APP_API_ROOT) {
    config.baseURL = env.VUE_APP_API_ROOT;
  }
  return config;
};

let defaultConfig = initConfig(process.env);
// 请求实例
const instance = axios.create(defaultConfig);
const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
  // 'X-Ksc-Region': 'cn-beijing-6',
  // 'X-Ksc-Region': 'cn-shanghai-3',
  // 'X-Ksc-Request-Id': uuid()
  // 'X-Action': 'action',
  // 'X-Version': 'version'
};
// 请求拦截
instance.interceptors.request.use(
  config => {
    // 统一在http请求的header都加上token
    // let token = cookies.getCookie('accessToken')
    // token && (config.headers.Authorization = token)
    if (window.appLocals.userInfo.type === 'iam') {
      // todo zy:kmr暂未支持子账号，统一使用了主账号Id

      headers['X-Ksc-Iam-Id'] = window.appLocals.userInfo.iam_user.id || '';
    }
    headers['X-Ksc-Region'] = window.appLocals.regionKey;
    console.log(window.appLocals.regionKey, 'window.appLocals.regionKey');
    headers['X-Ksc-Account-Id'] = window.appLocals.userInfo.userId;
    headers['X-Requested-With'] = 'XMLHttpRequest';
    headers['X-Ksc-Request-Id'] = uuid();
    config.headers = headers;

    return config;
  },
  error => {
    return Promise.error(error);
  }
);

//  OK = 200; （成功）

// 错误code
//  BAD_REQUEST = 400; （请求不正确）
//  PERSSION_DENIED = 401; （用户角色未授权）
//  USER_STATUS_ERROR = 402; （用户状态错误,目前是指订单状态）
//  USER_BUCKET_NOT_EXITS_ERROR = 410; （KS3 BUCKET 不存在）
//  USER_BUCKET_NO_PERMISSION_ERROR = 411; （KS3 BUCKET 无权限）
//  USER_ENDPOINT_INVALID_ERROR = 412; （KS3 ENDPOINT 地址不合法）
//  DATABASE_EXITS = 413; （库存在）
//  TABLE_EXITS = 414; （表存在）
//  REQUEST_VALIDATIONS_ERROR = 460; （查询请求格式错误）
//  INTERNAL_ERROR = 500; （内部错误，后端）
//  CREATE_ERROR = 506; (创建类失败，后端错误)
//  DELETE_ERROR = 507; (删除类失败，后端错误）
//  QUERY_ERROR = 508; (查询类失败，后端错误）
// res 格式：
// {
//   code: 0,
//   data: {
//     id: '',
//     status: 200,
//     message: '',
//     Total: {},
//     data: [],
//   },
//   msg:
// }

// 响应拦截
instance.interceptors.response.use(
  response => {
    // 通过返回状态判断响应是否成功
    if (response.status === 200) {
      let resData = response.data;
      resData.data = resData.data || {};
      console.log('resData', resData.data, resData);
      if (!resData.data.Total) {
        resData.data.Total = {};
      }
      if (!resData.data.Data) {
        resData.data.Data = [];
      }
      // node层校验用户信息失败
      if (resData.code === 401) {
        return Promise.reject(resData);
      }
      // 后端业务成功
      if (resData.data.Status && resData.data.Status == 200) {
        return Promise.resolve(resData);
      }
      // 权限处理
      if (resData.data.Status === 401) {
        // 直接刷新跳转到请求授权页面
        location.href = '/#/no-auth';
        // return Promise.resolve(resData);
      }
      // 其他错误
      // window.location.href = '/#/error'
      if (resData.data.Error) {
        console.log(resData.data.Error);
        resData.data = {
          Status: 500,
          Data: [],
          Message: `${resData.data.Error.Code} , ${resData.data.Error.Type} , ${resData.data.Error.Message}`,
          Total: {}
        };
      }
      // 统一错误提示
      let msg =
        resData.data.Message || ERROR_CODE[resData.data.Status] || '内部错误~';
      resData.msg = msg;
      return Promise.reject(resData);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    let commonStyle = {
      id: headers['X-Ksc-Request-Id'],
      msg: '发生错误，请刷新重试~'
    };
    if (error.response && error.response.status) {
      // 异常状态处理
      if (error.response.status == '401') {
        return Promise.reject(error);
      }
      if (error.response.status == '404') {
        console.log(error);
        return Promise.reject({
          id: headers['X-Ksc-Request-Id'],
          msg: '发生错误，请重试~'
        });
      }
      return Promise.reject({ error, ...commonStyle });
    }
    return Promise.reject({ error, ...commonStyle });
  }
);
const request = options => {
  return instance.request(options);
};

export default request;
